import { ReactNode } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Close, Search } from '@mui/icons-material';
import { ScopeFilter, Scope } from './ScopeFilter';
import { CountBadge, SectionToolbar, SettingsSearchField } from './settingsEntities.styles';

type Props = {
  scope?: Scope;
  onScopeChange?: (scope: Scope) => void;
  showScope?: boolean;
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  count: number;
  countNoun: string;
  filters?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

export const SettingsSection = ({
  scope,
  onScopeChange,
  showScope = false,
  search,
  onSearchChange,
  searchPlaceholder = 'Search…',
  count,
  countNoun,
  filters,
  actions,
  children,
}: Props) => (
  <div>
    <SectionToolbar>
      {showScope && scope && onScopeChange && <ScopeFilter value={scope} onChange={onScopeChange} />}
      {filters}
      <SettingsSearchField
        size="small"
        type="text"
        placeholder={searchPlaceholder}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        autoComplete="off"
        sx={{ flex: 1, minWidth: 180 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: search ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="Clear search"
                edge="end"
                onClick={() => onSearchChange('')}
                sx={{ color: 'text.secondary' }}
              >
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }}
      />
      {actions}
      <CountBadge>
        {count} {countNoun}
      </CountBadge>
    </SectionToolbar>
    {children}
  </div>
);

export default SettingsSection;
